import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.1_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@19._4c136b3db74ae832019be0332b9c327c/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["YnsLink"] */ "/vercel/path0/src/ui/yns-link.tsx");
